/** Initialize consent before any vendor loader can run, and notify loaded tags on withdrawal. */
export function updateTrackingConsent(allowed: boolean, gaId: string | null): void {
  const first = typeof window.gtag !== "function";
  window.dataLayer ??= [];
  window.gtag ??= function () { window.dataLayer!.push(arguments); };
  const state = (granted: boolean) => ({
    analytics_storage: granted ? "granted" : "denied",
    ad_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
  });
  try {
    if (first) window.gtag("consent", "default", state(false));
    window.gtag("consent", "update", state(allowed));
  } catch { /* A broken vendor must not prevent withdrawal for the other tags. */ }
  if (gaId) Object.assign(window, { [`ga-disable-${gaId}`]: !allowed });
  try { window.fbq?.("consent", allowed ? "grant" : "revoke"); } catch { /* Vendor unavailable. */ }
}

/** Keep the legacy contact-form journey payload, with only campaign parameters retained. */
export function recordVisitorJourney(): void {
  try {
    const key = "visitorJourney";
    const current = new URL(window.location.href);
    const params: Record<string, string> = {};
    for (const name of ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"]) {
      const value = current.searchParams.get(name);
      if (value) params[name] = value;
    }
    current.search = new URLSearchParams(params).toString();
    current.hash = "";
    const stored: unknown = JSON.parse(localStorage.getItem(key) ?? "[]");
    const journey: { url: string; timestamp: string; source: string; referrer?: string | null; params?: Record<string, string> }[] =
      Array.isArray(stored) ? stored.filter(entry => entry && typeof entry.url === "string").slice(-99) : [];
    if (journey.at(-1)?.url === current.href) return;
    let referrer: string | null = null;
    try { if (document.referrer) { const url = new URL(document.referrer); url.search = ""; url.hash = ""; referrer = url.href; } } catch { /* Invalid referrer. */ }
    journey.push({ url: current.href, timestamp: new Date().toISOString(), source: "next-navigation",
      ...(journey.length === 0 ? { referrer, params } : {}),
    });
    localStorage.setItem(key, JSON.stringify(journey));
  } catch { /* Tracking must never break navigation or forms when storage is unavailable. */ }
}
